import styled from 'styled-components';

// Text that is read but not seen: a label for assistive tech where the visual design already makes
// the meaning obvious, and a heading or legend a sighted reader does not need repeated.
//
// Here once rather than per feature. Four private copies had already drifted — one omitted the
// margin/padding/border reset, one used the space-separated `rect(0 0 0 0)` form — and
// visually-hidden text is exactly what a redesign disturbs, so an engineer modernising the pattern
// was fixing one copy and missing three.
//
// Both clip forms are present on purpose: `clip` is deprecated but still what older engines honour,
// and `clip-path: inset(50%)` is the current spelling. Keeping both is the standard belt-and-braces
// recipe, not an oversight.
//
// Renders a <span>. Where the element matters — a <legend> inside a <fieldset>, a <caption> on a
// table — pass `as`: this carries no custom props, so nothing leaks to the DOM through it.
export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;
